var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.75V26.25C22.5 24.9239 21.9732 23.6521 21.0355 22.7145C20.0979 21.7768 18.8261 21.25 17.5 21.25H10C8.67392 21.25 7.40215 21.7768 6.46447 22.7145C5.52678 23.6521 5 24.9239 5 26.25V28.75M22.5 6.41C23.5722 6.68796 24.5217 7.31408 25.1996 8.19008C25.8775 9.06608 26.2452 10.1424 26.2452 11.25C26.2452 12.3576 25.8775 13.4339 25.1996 14.3099C24.5217 15.1859 23.5722 15.812 22.5 16.09M30 28.75V26.25C29.9992 25.1422 29.6304 24.066 28.9517 23.1904C28.273 22.3148 27.3227 21.6895 26.25 21.4125M18.75 11.25C18.75 14.0114 16.5114 16.25 13.75 16.25C10.9886 16.25 8.75 14.0114 8.75 11.25C8.75 8.48858 10.9886 6.25 13.75 6.25C16.5114 6.25 18.75 8.48858 18.75 11.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/manageUsers.33b7720ffe06d49d9a5123f51d815e5f.svg";
export { ForwardRef as ReactComponent };